import React from "react";
import './style.css'

const ChatButton = ({chatOpen,setChatOpen}) => {
  return (
    <button
      className={`chat-button ${!chatOpen ? "bounce-icon" : ""}`}
      onClick={() => setChatOpen(!chatOpen)}
    >
      {chatOpen ? "✖️" : "💬"}
    </button>
  );
};

export default ChatButton;
